export default __webpack_public_path__ + "static/media/icon-suvs.058b664c.svg";